import React from "react";

/**
 * UnifiedCard - A reusable card component with consistent styling
 * across all sections of the website
 * 
 * Features:
 * - Consistent border-radius (16px)
 * - Consistent shadow depth (md)
 * - Smooth hover transitions
 * - Teal accent on hover
 * - Glassmorphism effect on dark backgrounds
 */

const UnifiedCard = ({ children, className = "", variant = "default", onClick, href, ...props }) => {
  const cardStyles = {
    default: {
      background: "#ffffff",
      border: "1px solid rgba(64, 168, 196, 0.15)",
      borderRadius: "16px",
      boxShadow: "0 4px 16px rgba(8, 32, 50, 0.08)",
      padding: "32px 24px",
    },
    glass: {
      background: "rgba(255, 255, 255, 0.05)",
      border: "1px solid rgba(64, 168, 196, 0.2)",
      borderRadius: "16px",
      boxShadow: "0 4px 16px rgba(8, 32, 50, 0.08)",
      padding: "32px 24px",
      backdropFilter: "blur(10px)",
    },
    outline: {
      background: "transparent",
      border: "2px solid rgba(64, 168, 196, 0.3)",
      borderRadius: "16px",
      boxShadow: "none",
      padding: "28px 20px",
    },
  };

  const Tag = onClick ? "div" : (href ? "a" : "div");

  const tagProps = onClick ? { onClick } : (href ? { href } : {});

  return (
    <Tag
      className={`unified-card ${variant} ${className}`}
      style={cardStyles[variant]}
      {...tagProps}
      {...props}
    >
      {children}
      <style>{`
        .unified-card {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          flex-direction: column;
        }
        .unified-card:hover {
          transform: translateY(-4px);
        }
        @media (prefers-reduced-motion: reduce) {
          .unified-card {
            transition: none;
          }
          .unified-card:hover {
            transform: none;
          }
        }
      `}</style>
    </Tag>
  );
};

export default UnifiedCard;
